import * as actionTypes from "./actionTypes";

const initialState = {
  error: null,
  loading: false,
  updating: false,
  total: 0,
  pageSize: 10,
  columns: [],
  dataSource: [],
  searchText: ""
};

const fetchCarCategoriesStart = (state) => ({
  ...state,
  loading: true
});

const fetchCarCategoriesSuccess = (state, action) => ({
  ...state,
  total: action.data.totalCars || 0,
  pageSize: action.data.pageSize || 10,
  columns: action.data.columns || [],
  dataSource: action.data.dataSource || [],
  error: null,
  loading: false
});

const fetchCarCategoriesFail = (state, action) => ({
  ...state,
  error: action.error,
  loading: false
});

const updateCarCategoryStart = (state) => ({
  ...state,
  updating: true
});

const updateCarCategorySuccess = (state) => ({
  ...state,
  updating: false
});

const updateCarCategoryFail = (state, action) => ({
  ...state,
  error: action.error,
  updating: false
});

const checkCarCategoryStart = (state) => ({
  ...state,
  updating: true
});

const checkCarCategorySuccess = (state) => ({
  ...state,
  updating: false
});

const checkCarCategoryFail = (state, action) => ({
  ...state,
  error: action.error,
  updating: false
});

const setSearchInput = (state, action) => ({
  ...state,
  searchText: action.data
});

const carCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAR_CATEGORIES_START:
      return fetchCarCategoriesStart(state);

    case actionTypes.FETCH_CAR_CATEGORIES_SUCCESS:
      return fetchCarCategoriesSuccess(state, action);

    case actionTypes.FETCH_CAR_CATEGORIES_FAIL:
      return fetchCarCategoriesFail(state, action);

    case actionTypes.UPDATE_CAR_CATEGORY_START:
      return updateCarCategoryStart(state);

    case actionTypes.UPDATE_CAR_CATEGORY_SUCCESS:
      return updateCarCategorySuccess(state);

    case actionTypes.UPDATE_CAR_CATEGORY_FAIL:
      return updateCarCategoryFail(state, action);

    case actionTypes.CHECK_CAR_CATEGORY_START:
      return checkCarCategoryStart(state);

    case actionTypes.CHECK_CAR_CATEGORY_SUCCESS:
      return checkCarCategorySuccess(state);

    case actionTypes.CHECK_CAR_CATEGORY_FAIL:
      return checkCarCategoryFail(state, action);

    case actionTypes.SET_CAR_CATEGORY_SEARCH_INPUT:
      return setSearchInput(state, action);

    default:
      return state;
  }
};

export default carCategoryReducer;
